export async function getMe() {
  const res = await fetch('/api/auth/me', { credentials: 'include' });
  if (res.status === 401) return { user: null };
  return res.json();
}

export async function logout() {
  await fetch('/api/auth/logout', { method: 'POST', credentials: 'include' });
}